export const UPDATE_NOTIFICATIONS_LIST = "notif/UPDATE_NOTIFICATIONS_LIST";
export const APPEND_NOTIFICATIONS_LIST = "notif/APPEND_NOTIFICATIONS_LIST";
export const UPDATE_NOTIFICATION_STATUS = "notif/UPDATE_NOTIFICATION_STATUS";
export const REMOVE_REQUEST_NOTIFICATION = "notif/REMOVE_REQUEST_NOTIFICATION";
export const ADD_RECEIVED_NOTIFICATION = "notif/ADD_RECEIVED_NOTIFICATION";
export const DECREMENT_NOTIF_COUNT = "user/DECREMENT_NOTIF_COUNT";
export const SET_SEEN_NOTIFICATION = "notif/SET_SEEN_NOTIFICATION";